"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const keautils_1 = require("keautils");
const filtrarOrdenar_1 = require("./filtrarOrdenar");
const files_1 = require("../../files");
const downloadjs_1 = require("../../downloadjs");
const text_1 = require("./text");
const moment = require("moment");
/**Formatea una fecha con un formato compatible con el Excel*/
function exportDate(x) {
    return moment(x).format("YYYY-MM-DD HH:mm:ss");
}
/**Devuelve una celda de CSV sin el separador o las comillas */
function toCsvCell(data) {
    if (data == null)
        return "";
    if (typeof data == "string") {
        //quitamos las comillas y las comas
        const r = data.replace(/(?:\r?\n|\r)|"|,/g, "");
        return r;
    }
    else if (typeof data == "number") {
        const r = "" + data;
        return r;
    }
    else if (data instanceof Date) {
        //Ya que excel no soporta el formato ISO 8601 exportamos con un formato diferente:
        const r = exportDate(data);
        return r;
    }
    else if (typeof data == "boolean") {
        const r = data ? "Si" : "No";
        return r;
    }
    else if (data instanceof Array) {
        return data.join(", ");
    }
    else if (typeof data == "object") {
        return toCsvCell(Object.keys(data));
    }
    const x = data;
    return "" + x;
}
/**Convierte una fila de datos a un CSV */
function toCsvRow(row) {
    return row
        .map(cell => "\"" + toCsvCell(cell) + "\"")
        .reduce((a, b) => a == "" ? b : a + "," + b, "");
}
/**Codigo para convertir los datos a CSV */
function toCSV(data) {
    const newLine = "\r\n";
    return data
        .map(row => toCsvRow(row))
        .reduce((a, b) => a == "" ? b : a + newLine + b, "");
}
exports.toCSV = toCSV;
/**Genera las filas de un CSV */
function generateCsvRows(rows, state, columns) {
    const filtroColumns = keautils_1.mapObject(columns, value => filtrarOrdenar_1.gridColumnToFiltroOrdenColumn(rows, value));
    const rowsSync = rows;
    const itemsFiltro = filtrarOrdenar_1.getItemCellData(rowsSync, filtroColumns);
    const filteredData = filtrarOrdenar_1.filtrarOrdenar(itemsFiltro, state.filtroOrden, filtroColumns).map(x => x.original);
    const exportMap = state.export;
    const mappedColumns = exportMap.map(key => columns[key]);
    const toCsvCell = (cell) => cell.string == undefined ? text_1.cellToText(cell.data) : cell.string;
    const toCsvRow = (row) => mappedColumns.map(col => toCsvCell(col.cell(row)));
    const csv = filteredData.map(toCsvRow);
    const header = mappedColumns.map(x => x.title);
    return [header, ...csv];
}
exports.generateCsvRows = generateCsvRows;
/**Descarga el CSV del grid */
function downloadCsv(rows, state, columns) {
    const data = generateCsvRows(rows, state, columns);
    const str = toCSV(data);
    const blob = files_1.stringToBlob(str);
    downloadjs_1.download(blob, "Lista.csv");
}
exports.downloadCsv = downloadCsv;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/simpleGrid/csv.js
// module id = 2233
// module chunks = 0